import styled from 'styled-components';

const StyledTransportCardWrapper = styled.div`
  position: relative;
  margin: 3rem 0;
  padding: 1.5rem 0;
  gap: 1rem;
`;

const StyledTransportCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
`;

const StyledTransportCardHeaderTitle = styled.h4`
  font-weight: 700;
  font-size: 3rem;
`;

const StyledTransportBody = styled.div`
  padding: 2rem;
  background-color: #fcfcfc;
  border: 1px solid #ebebeb;
  border-radius: 7px;
  min-height: 300px;
  display: flex;
  align-items: center;
`;

const StyledTransportInfo = styled.div`
  h3 {
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 0.5rem;
    color: ${(props) => props.theme.color.bodyTextColor};
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-weight: 600;

    strong {
      font-weight: 700;
    }
  }
`;

const StyledContentGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 0.5fr 1fr;
  row-gap: 1.5rem;
  column-gap: 3rem;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  // Show only one column on mobile for just the main image
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export {
  StyledTransportCardWrapper,
  StyledTransportCardHeader,
  StyledTransportBody,
  StyledTransportCardHeaderTitle,
  StyledTransportInfo,
  StyledContentGrid,
};
